import React, { useEffect, useLayoutEffect } from 'react';
import styles from './style.module.scss';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import Heading from 'shared/components/common/heading/Heading';
import { LimitedAccessNewIcon } from 'assets/index';
import CustomButton from 'shared/components/common/custom_button/CustomButton';

export default function LimitedAccess({ show, handleClose }) {
    // const {
    //     theme: { theme }
    // } = useSelector((state) => state);
    useLayoutEffect(() => {
        changeModalSize();
        window.addEventListener('resize', changeModalSize);
        return () => window.removeEventListener('resize', changeModalSize);
    }, [show]);
    const changeModalSize = () => {
        let doc = document.querySelector('.modal-dialog');
        if (doc) {
            if (show) {
                if (window.screen.width > 580) {
                    doc.style.width = '568px';
                } else {
                    doc.style.width = 'auto';
                }
            } else {
                // doc.style.width = 'auto';
            }
        }
    };

    return (
        <Modal size="lg" show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body className={classNames(styles.ModalBody, `ModalBackground`)}>
                <div className={classNames(styles.LimitedAccessContainer)}>
                    <div className={classNames(styles.LimitedAccessHeader)}>
                        <Heading heading={'Limited Access'} headingStyle={classNames(styles.Heading)} />
                    </div>
                    <div className={classNames(styles.ContentContainer)}>
                        <LimitedAccessNewIcon className={styles.LimitedIcon} />
                        <div className={classNames(styles.LimitedAccessDescContainer)}>
                            <Heading heading={'Can’t Access This Info!'} headingStyle={classNames(styles.RestrictHeading)} />
                            <p className={classNames(styles.RestrictDesc)}>You can’t access this info since you have a limited access, You may contact the admin to remove this restriction!</p>
                            <CustomButton text={'Okay'} submitHandle={handleClose} containerStyle={classNames(styles.BtnOkay)} />
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
